if (!customElements.get('sembonia-product-tabs')) {
  customElements.define('sembonia-product-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.addEventListener('click', (event) => this.selectSwatch(event), options);
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(tab), options);
        tab.addEventListener('keydown', (event) => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          this.select(this.tabs[next]);
          this.tabs[next].focus();
        }, options);
      });
      this.addEventListener('shopify:block:select', (event) => {
        const tab = event.target.closest('[role="tab"]');
        if (tab) this.select(tab);
      }, options);
    }
    selectSwatch(event) {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const swatch = event.target.closest('a.featured-product-swatch[data-swatch-image]');
      if (!swatch || !this.contains(swatch)) return;
      const card = swatch.closest('.product-card-wrapper');
      const images = card?.querySelectorAll('.card__media .media > img');
      if (!images?.length) return;
      event.preventDefault();
      event.stopPropagation();
      const selectionRequest = {};
      this.selectionRequest = selectionRequest;
      this.querySelectorAll('.featured-product-swatch[aria-current="true"]').forEach(item => item.removeAttribute('aria-current'));
      swatch.setAttribute('aria-current', 'true');
      // Preload before replacing the visible image; a later click wins the race.
      card.swatchRequest = swatch;
      const preview = new Image();
      preview.onload = () => {
        if (!this.isConnected || card.swatchRequest !== swatch) return;
        // Do not show the previous colour's secondary image while hovering.
        images.forEach(image => {
          image.removeAttribute('srcset');
          image.src = swatch.dataset.swatchImage;
          image.alt = swatch.dataset.swatchAlt;
        });
        card.dataset.productUrl = swatch.href;
        // Only the latest clicked card receives the ring, even if images load out of order.
        if (this.selectionRequest === selectionRequest) swatch.setAttribute('aria-current', 'true');
      };
      preview.onerror = () => {
        if (this.isConnected && this.selectionRequest === selectionRequest && card.swatchRequest === swatch) window.location.assign(swatch.href);
      };
      preview.src = swatch.dataset.swatchImage;
    }
    select(selected) {
      const id = selected.getAttribute('aria-controls');
      this.tabs.forEach(tab => {
        tab.setAttribute('aria-selected', String(tab === selected));
        tab.tabIndex = tab === selected ? 0 : -1;
      });
      this.querySelectorAll('[role="tabpanel"]').forEach(panel => { panel.hidden = panel.id !== id; });
      this.querySelectorAll('[data-browse]').forEach(link => { link.hidden = link.dataset.browse !== id; });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  });
}
